import { t } from "@/i18n-js/instance";
import { SanitizeHTMLString } from "@circle-react/components/shared/uikit/SanitizeContent";
import { usePunditUserContext } from "@circle-react/contexts";
import { Typography } from "@circle-react-uikit/Typography";
import { WarningWrapper } from "./WarningWrapper";

export const ExpiredTrial = () => {
  const { currentCommunity } = usePunditUserContext();

  return (
    <WarningWrapper>
      <Typography.LabelLg weight="semibold">
        {t("subscription.expired_trial_title")}
      </Typography.LabelLg>
      <Typography.BodyMd color="text-default">
        {t("pricing_plans.to_access_upgrade", {
          community_name: currentCommunity?.name,
        })}

        <SanitizeHTMLString content={t("pricing_plans.please_reach_out")} />
      </Typography.BodyMd>
    </WarningWrapper>
  );
};
